import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
  selector: 'error-global-error-popup',
  templateUrl: './global-error-popup.component.html'
})
export class GlobalErrorPopupComponent {

  public title = input.required<string>();
  public description = input.required<string>();
  public isOpen = input.required<boolean>();
  public showOverlay = input<boolean>(false);

  @Output() closePopup = new EventEmitter<void>();

  public onCloseErrorPopup(): void {
    this.closePopup.emit();
  }
}
